import { OrderStatus } from "../types/order.type";

export const getPaymentStatus = (type: string) => {
  switch (type) {
    case OrderStatus.CANCELED:
      return "Cancelled";
    case OrderStatus.PENDING:
      return "Pending";
    case OrderStatus.PAID:
      return "Paid";
    case OrderStatus.PREPARING:
      return "Preparing";
    case OrderStatus.PACKED:
      return "Packed";
    case OrderStatus.DELIVERED:
      return "Delivered";
    case OrderStatus.RECEIVED:
      return "Received";
    case OrderStatus.SHIPPED:
      return "Shipped";
    default:
      return "Unknown";
  }
};
